<template>
  <TenderInfoPanel
    :can_change_winners.sync="$_canChangeWinners"
    :can_edit="can_edit"
    :change_winner_mode.sync="changeWinnerMode"
    :tender.sync="item"
    @changeAcceptors="$_setAcceptorsProps"
    @needOpenDocuments="$_openDocumentTab">
    <div class="tender-page-left">
      <div class="tender-page-header">
        <Breadcrumbs
          :items="breadcrumbs"/>
        <TenderTopActions
          :tender="item"/>
      </div>
      <div
        class="pt-2 width-100">
        <template
          v-if="loading">
          <v-skeleton-loader
            class="mt-10 pr-8"
            type="heading"
            width="100%"/>
          <v-skeleton-loader
            class="mt-3 pr-8"
            type="sentences"
            width="100%"/>
          <v-skeleton-loader
            class="mt-4 main__green mt-5"
            type="table-thead, table-tbody"
            width="100%"/>
        </template>
        <template v-else-if="item">
          <div class="flex flex-between">
            <div
              class="h1-headline text-left pb-2">
              <TooltipedText
                :line-count="3"
                :value="item ? item.title : '–'"/>
            </div>
            <div
              v-if="($acl.check('onlyTenders') || $acl.check('onlyAgreement')) && item && !item.hasRoute"
              class="flex flex-right">
              <template v-if="can_edit">
                <CreateFrameAuction :tender="item"/>
                <ChangeWinners
                  v-if="$_canChangeWinners && changeWinnerMode"
                  :changed_winners.sync="changedWinners"
                  :tender="item"
                  @submit="closeChangeWinnerMode"/>
                <NewTenderStageBtn
                  v-if="!$_hasWinners && item && item.tenderStatus && item.tenderStatus.id == statuseKeys.BID_ANALYSIS && $can('show', 'allowCreateNewStageAfterUnsuccessfulTender')"
                  class="mr-2"
                  :tender="item"/>
                <template v-if="!$_agreements || !$_agreements.length || agreementFinished">
                  <template v-if="$_hasWinners">
                    <ModalWinnerReasonConfirm
                      v-if="$_showWinnerReasonModal(item)"
                      :activator-class="{'mr-5': imAcceptor}"
                      :tender="item"
                      @apply="$_confirmSelectionClick"/>
                    <sButton
                      v-else
                      :class="{'mr-5': imAcceptor}"
                      data-qa="btn-checkWinner"
                      @click="$_confirmSelectionClick()">
                      {{ $t('Tenders.ConfirmSelection') }}
                    </sButton>
                    <DialogTemplateToolkit
                      data-qa="partial-group-winner-warning"
                      :dialog="showPartialGroupWinnerWarning"
                      first_btn="Tenders.Continue"
                      :title="$t('Tenders.PartialGroupWinnerTitle')"
                      @apply="$_goToCheckWinner"
                      @close="showPartialGroupWinnerWarning = false">
                      <template #card-text>
                        {{ $t('Tenders.PartialGroupWinnerMessage') }}
                      </template>
                    </DialogTemplateToolkit>
                  </template>
                  <ModalTenderFinish
                    v-else-if="item && item.tenderStatus && item.tenderStatus.id == statuseKeys.BID_ANALYSIS"
                    :class="{'mr-5': imAcceptor}"
                    :tender="item"/>
                  <PrequalificationBtns
                    v-if="item && item.tenderStatus && item.tenderStatus.id == statuseKeys.PREQUALIFICATION"
                    :class="{'mr-5': imAcceptor}"
                    :tender="item"
                    @showBid="$_openTab(1)"/>
                </template>
              </template>
              <template v-if="imAcceptor">
                <template v-if="!imAcceptor.hideDisagreeButton">
                  <TenderAgreementResult
                    v-if="$_disagreeFormioParams && $_disagreeFormioParams.version"
                    class="mr-5"
                    :data-qa="'reject'"
                    :decision="false"
                    :form-params="$_disagreeFormioParams"
                    :label="imAcceptor ? imAcceptor.disagreeButtonTitle : ''"
                    :loading.sync="agree_loading"
                    :tender="item"
                    @success="getItem(true)"/>
                  <RejectDialog
                    v-else
                    class-name="reject-btn mr-5"
                    :disabled="agree_loading == 'resolve'"
                    :form-params="$_disagreeFormioParams"
                    :label="imAcceptor ? imAcceptor.disagreeButtonTitle : ''"
                    :loading.sync="agree_loading"
                    :tender.sync="item"
                    @callback="$_agree"/>
                </template>
                <TenderAgreementResult
                  v-if="$_agreeFormioParams && $_agreeFormioParams.version"
                  :data-qa="'agree'"
                  :decision="true"
                  :form-params="$_agreeFormioParams"
                  :label="imAcceptor ? imAcceptor.agreeButtonTitle : ''"
                  :loading.sync="agree_loading"
                  :tender="item"
                  @success="getItem(true)"/>
                <ConfirmTenderAgreement
                  v-else
                  :acceptors="$_agreements"
                  :callback="$_agree"
                  :disabled="agree_loading == 'reject'"
                  :form-params="$_agreeFormioParams"
                  :label="imAcceptor ? imAcceptor.agreeButtonTitle : ''"
                  :loading.sync="agree_loading"
                  :tender="item"/>
              </template>
            </div>
          </div>
          <div
            class="text-start h8-text"
            data-qa="item-category">
            {{ item && item.category ? item.category.code + ' ' + item.category.title :'–' }}
          </div>
          <TenderItemTabs
            ref="tabs"
            :can_edit="can_edit"
            :change_winner_mode.sync="changeWinnerMode"
            :tender="item"/>
        </template>
      </div>
    </div>
  </TenderInfoPanel>
</template>
<script>
import TenderInfoPanel from 'components/tenders/tender page/TenderInfoPanel.vue'
import TenderAgreementResult from 'components/tenders/dialogs/TenderAgreementResult.vue'

import Breadcrumbs from 'components/common/elements/Breadcrumbs.vue'
import TenderTopActions from 'components/tenders/TenderTopActions.vue'
import ChangeWinners from 'components/tenders/dialogs/ChangeWinners.vue'
import RejectDialog from 'components/purchasing/purch item/RejectDialog.vue'
import TenderItemTabs from 'components/tenders/tender page/TenderItemTabs.vue'
import NewTenderStageBtn from 'components/tenders/dialogs/NewTenderStageBtn.vue'
import CreateFrameAuction from 'components/tenders/tender page/CreateFrameAuction.vue'
import PrequalificationBtns from 'components/tenders/tender page/PrequalificationBtns.vue'
import ConfirmTenderAgreement from 'components/tenders/dialogs/ConfirmTenderAgreement.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'
import ModalTenderFinish from 'components/tenders/dialogs/cancelTender/ModalTenderFinish.vue'
import ModalWinnerReasonConfirm from 'components/tenders/dialogs/ModalWinnerReasonConfirm.vue'

import TooltipedText from 'components/common/blocks/tooltiped text/TooltipedText.vue'

import tenderItem from './tenderItem'
import { eventBus } from '@/main'

import winnerReasonMixin from 'mixins/winnerReasonMixin.js'

export default {
  name: 'TenderItemPanel',
  mixins: [ tenderItem, winnerReasonMixin ],
  data() {
    return {
      showPartialGroupWinnerWarning: false,
      reasonNotBestPrice: null,
    }
  },
  computed: {
    currentEntityKey() {
      return this.item?.tenderId?.toString()
    },
    breadcrumbs() {
      return [
        {
          index: 0,
          text: this.$t('Tenders.Tenders'),
          maxLength: 100,
          to: { name: 'tenders', params: {org: this.$route.params.org}}
        },
        {
          index: 1,
          maxLength: 20,
          text: (this.item?.title || '')/*' #' + (this.item?.tenderNumber || ''),*/
        }
      ]
    },
  },
  methods: {
    closeChangeWinnerMode(save) {
      eventBus.$emit('onCloseChangeWinnerMode', !save)
    },
    $_confirmSelectionClick(reason) {
      this.reasonNotBestPrice = typeof reason === 'string' ? reason : undefined
      if (this.$_hasPartialGroupWinners) {
        this.showPartialGroupWinnerWarning = true
      } else {
        this.$_goToCheckWinner()
      }
    },
    $_goToCheckWinner() {
      this.showPartialGroupWinnerWarning = false
      this.$router.push({name: 'checkWinner', params: {tenderId: this.item.tenderId, org: this.$route.params.org, reason: this.reasonNotBestPrice}}).catch(() => {})
    },
  },
  components: {
    Breadcrumbs,
    RejectDialog,
    TooltipedText,
    ChangeWinners,
    TenderItemTabs,
    TenderInfoPanel,
    TenderTopActions,
    ModalTenderFinish,
    NewTenderStageBtn,
    ModalWinnerReasonConfirm,
    CreateFrameAuction,
    PrequalificationBtns,
    TenderAgreementResult,
    ConfirmTenderAgreement,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.tender-page-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--v-main__green-base);
  //max-width: calc(100vw - 55px);
  height: 44px;
  display: grid;
  padding: 0 !important;
  grid-template-columns: auto auto;
  border-bottom: 1px solid var(--main__green_locked);
  &::after {
    content: "";
    border-bottom: 1px solid var(--main__green_locked);
    position: absolute;
    right: -17px;
    bottom: -1px;
    width: 18px;
    height: 2px;
  }
}
.tender-page-left {
  max-width: 100vw;
  padding-left: 20px;
  padding-bottom: 16px;
  padding-right: 12px;
  position: relative;
}
::v-deep table tbody tr.blink-row {
  animation: blink 3s;
  animation-iteration-count: 1;
  opacity: 1;
}

@keyframes blink {
  15% { opacity: 0.1; }
  30% { opacity: 1; }
  45% { opacity: 0.3; }
  60% { opacity: 1;  }
  75% { opacity: 0.5; }
}
.v-subheader {
  height: unset !important;
}
.purchase-info {
  .v-subheader {
    font-size: 12px;
  }
}
.divider {
  border: 1px solid black !important;
  margin: 2px 0;
}
.tender-info {
  height: 100vh;
  overflow-y: auto;
}
</style>
<style lang="scss">
#components-layout-tender-item {
  height: 100vh;
  overflow-y: auto;


  .comment-block {
    height: auto;
    .history-container {
      height: fit-content;
    }
  }
  .v-skeleton-loader .v-skeleton-loader__table-thead,.v-skeleton-loader .v-skeleton-loader__table-tbody {
    background-color: var(--v-main__green-base);
  }
    .info-list, .info-list .sticky {
      background-color: var(--v-secondary__green_chosen-base);
    }

}
</style>
